import React, { useEffect, useState } from "react";
import { Field } from "formik";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

const QueueSelectSingle = () => {
    const [queues, setQueues] = useState([]);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/queue");
                setQueues(data);
            } catch (err) {
                toastError(`QUEUESELETSINGLE >>> ${err}`);
            }
        })();
    }, []);

    return (
        <FormControl variant="outlined" margin="dense" fullWidth>
            <InputLabel id="queue-selection-label">
                {i18n.t("queueSelect.inputLabel")}
            </InputLabel>
            <Field
                as={Select}
                label={i18n.t("queueSelect.inputLabel")}
                name="queueId"
                labelId="queue-selection-label"
                id="queue-selection"
                fullWidth
            >
                {queues.map(queue => (
                    <MenuItem key={queue.id} value={queue.id}>
                        {queue.name}
                    </MenuItem>
                ))}
            </Field>
        </FormControl>
    );
};

export default QueueSelectSingle;
